module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/cnaes/cnaes-edit/cnaes-edit.component.css
// module id = ./src/app/views/cnaes/cnaes-edit/cnaes-edit.component.css
// module chunks = main